module.exports = __webpack_public_path__ + "img/sapiencia3.a3a02bec.png";